// The time class, from the game's time control.
import { timeClassOf } from '../classify.ts';
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { TIME_CLASSES } from '@chess/api-model';

export const timeClass: FilterCriterion<'timeClass'> = {
  key: 'timeClass',
  query: 'time',
  many: true,
  parse: oneOf(TIME_CLASSES),
  format: (v) => v,
  matches: (game, v) => timeClassOf(game.timeControl) === v,
  control: {
    kind: 'choice',
    order: 30,
    label: 'Time',
    options: [['bullet', 'Bullet'], ['blitz', 'Blitz'], ['rapid', 'Rapid'], ['daily', 'Daily']],
  },
};
